exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-viewer{background-color:#fff;padding:20px;padding-bottom:140px;min-width:500px;min-height:500px;max-width:1000px}.text-viewer pre{background:none;border:none;word-break:break-word;word-wrap:normal;white-space:break-spaces}", ""]);

